let result, loadingPromise;
const load = () => {
  if (result) return Promise.resolve(result);
  if (loadingPromise) return loadingPromise;
  loadingPromise = import("./dialog-api-tbPQMPB1.js").then((module) => result = module.api).catch((err) => console.error(`Failed to load "msntDialog" =>`, err));
  return loadingPromise;
};
const getDialog = (fn) => load().then((api) => {
  if (!api) return;
  fn == null ? void 0 : fn(api);
  return api;
});
export {
  getDialog
};
//# sourceMappingURL=dialog.js.map
